var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-blank",on:{"click":function($event){return _vm.openSelector()}}},[_c('span',[_vm._v(_vm._s(_vm.$t("survey.select_question")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }